export default "__VITE_ASSET__DLJYNOXT__"